import React from "react";
import PropTypes from "prop-types";

//
import ReactPaginate from "react-paginate";

function Pagination({ currentPage, lastPage, changePage }) {
  return (
    <ReactPaginate
      breakLabel="..."
      onPageChange={changePage}
      pageRangeDisplayed={2}
      pageCount={lastPage}
      marginPagesDisplayed={2}
      forcePage={currentPage}
      className="pagination"
      previousLabel={<i className="las la-angle-left"></i>}
      nextLabel={<i className="las la-angle-right"></i>}
    />
  );
}

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  lastPage: PropTypes.number.isRequired,
  changePage: PropTypes.func.isRequired,
};

export default Pagination;
